// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <g transform="translate(3 3)">
    <path d="M2.7,12.7c-1.5,0-2.7,1.2-2.7,2.7S1.2,18,2.7,18s2.7-1.2,2.7-2.7l0,0C5.3,13.9,4.1,12.7,2.7,12.7z" />
    <path d="M0.3,5.9C0.1,5.9,0,6,0,6.2v3.4c0,0.2,0.1,0.3,0.3,0.3c4.4,0,7.9,3.5,7.9,7.9c0,0.2,0.1,0.3,0.3,0.3h3.4
      c0.2,0,0.3-0.1,0.3-0.3l0,0C12.1,11.2,6.8,5.9,0.3,5.9z" />
    <path d="M18,17.7C17.9,8,10,0.1,0.3,0C0.1,0,0,0.1,0,0.3v3.5C0,3.9,0.1,4,0.3,4C7.8,4,14,10.1,14,17.7c0,0,0,0,0,0.1
      c0,0.2,0.1,0.3,0.3,0.3h3.5C17.9,18,18.1,17.9,18,17.7L18,17.7z" />
  </g>
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-rss-CapSBFW-.js.map
